import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { ClassificationEmployeur } from '../model/classification-employeur';

@Injectable({
    providedIn: 'root'
  })
  export class ClassificationEmployeurService{
  
    constructor(private _restClientService : RestClientService) { }


    getAll() {
        return this._restClientService.load<ClassificationEmployeur[]>('classification-employeur/find-all');
    }
      
    getById(id){
      return this._restClientService.load<ClassificationEmployeur>('classification-employeur/find-by-id/'+id);
    }
      
    put(classificationEmployeur) {
      return  this._restClientService.put<ClassificationEmployeur>(`classification-employeur/update`, classificationEmployeur);
    }
    
    post(classificationEmployeur) {
      return  this._restClientService.save<ClassificationEmployeur>('classification-employeur/add', classificationEmployeur);
    }
    
    
}      

    